if (!customElements.get('b2h-recovery-readiness')) {
  customElements.define('b2h-recovery-readiness', class B2HRecoveryReadiness extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-recovery-form]');
      this.auditFields = this.querySelector('[data-readiness-audit-fields]');
      this.urgentResult = this.querySelector('[data-active-missing-result]');
      this.result = this.querySelector('[data-recovery-result]');
      this.summary = this.querySelector('[data-recovery-summary]');
      this.actions = this.querySelector('[data-recovery-actions]');
      this.error = this.querySelector('[data-recovery-error]');
      if (!this.form || !this.auditFields) return;

      this.form.addEventListener('change', (event) => this.onChange(event));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.form.addEventListener('reset', () => this.onReset());
      this.setAuditAvailability(false);
    }

    setAuditAvailability(enabled) {
      this.auditFields.disabled = !enabled;
      this.auditFields.hidden = !enabled;
      if (!enabled) this.hideResult();
    }

    clearFoundations() {
      for (const input of this.querySelectorAll('[data-foundation] input:checked')) {
        input.checked = false;
      }
      this.hideError();
      this.hideResult();
    }

    onChange(event) {
      const status = event.target.closest('input[name="pet_status"]');
      if (status && this.form.contains(status)) {
        const isSafe = status.value === 'safe_present';
        if (!isSafe) this.clearFoundations();
        this.setAuditAvailability(isSafe);
        if (this.urgentResult) {
          this.urgentResult.hidden = isSafe;
          if (!isSafe) this.urgentResult.focus({ preventScroll: false });
        }
        return;
      }

      if (event.target.closest('[data-foundation]')) {
        this.hideError();
        this.hideResult();
      }
    }

    selectedFoundations() {
      return [...this.querySelectorAll('[data-foundation]')].map((foundation) => ({
        label: foundation.querySelector('legend')?.textContent.trim().replace(/^\d+/, '').trim() || '',
        value: foundation.querySelector('input:checked')?.value || '',
      }));
    }

    showError() {
      if (!this.error) return;
      this.error.hidden = false;
      this.error.focus({ preventScroll: false });
    }

    hideError() {
      if (this.error) this.error.hidden = true;
    }

    hideResult() {
      if (this.result) this.result.hidden = true;
    }

    onSubmit(event) {
      event.preventDefault();
      const status = this.form.querySelector('input[name="pet_status"]:checked')?.value;
      if (status !== 'safe_present') return;

      const foundations = this.selectedFoundations();
      if (foundations.some(({ value }) => !value)) {
        this.showError();
        return;
      }

      this.hideError();
      const counts = foundations.reduce((totals, { value }) => {
        totals[value] += 1;
        return totals;
      }, { current: 0, gap: 0, unsure: 0 });

      const parts = [
        this.summary.dataset.readyTemplate.replace('[count]', counts.current),
        this.summary.dataset.gapTemplate.replace('[count]', counts.gap),
        this.summary.dataset.unsureTemplate.replace('[count]', counts.unsure),
      ];
      this.summary.textContent = parts.join(' ');

      this.actions.replaceChildren();
      const priority = foundations.filter(({ value }) => value !== 'current');
      const items = priority.length > 0 ? priority : foundations.slice(0, 1);
      for (const item of items) {
        const listItem = document.createElement('li');
        const template = item.value === 'current'
          ? this.actions.dataset.currentTemplate
          : this.actions.dataset.attentionTemplate;
        listItem.textContent = template.replace('[foundation]', item.label);
        this.actions.append(listItem);
      }

      this.result.hidden = false;
      this.result.focus({ preventScroll: false });
    }

    onReset() {
      requestAnimationFrame(() => {
        this.clearFoundations();
        this.setAuditAvailability(false);
        if (this.urgentResult) this.urgentResult.hidden = true;
        this.hideError();
        this.hideResult();
      });
    }
  });
}
